// src/components/GroomersTableHead.js
import React from "react";
import { TableRow, TableCell, TableSortLabel } from "@mui/material";

function GroomersTableHead({ columns, order, orderBy, onSortRequest }) {
    return (
        <TableRow>
            {columns.map((column) => (
                <TableCell key={column.id}>
                    {column.sortable ? (
                        <TableSortLabel
                            active={orderBy === column.id}
                            direction={orderBy === column.id ? order : 'asc'}
                            onClick={() => onSortRequest(column.id)}
                        >
                            {column.label}
                        </TableSortLabel>
                    ) : (
                        column.label
                    )}
                </TableCell>
            ))}
        </TableRow>
    );
}

export default GroomersTableHead;